<template>
  <v-expansion-panels :value="null">
    <v-expansion-panel>
			<v-expansion-panel-header class="expansion-panel-border green">
				<v-row>
						<v-icon>account_balance_wallet</v-icon>
						<h3 class="title text-uppercase ml-3">
							Рахунки та оплати
						</h3>
				</v-row>
			</v-expansion-panel-header>
			<v-expansion-panel-content>
				<v-row>
					<v-col>
						<SimpleTable
							:headers="headers"
							:height="'auto'"
							:loading="loading"
							:table-shadow="false"
							:items-per-page="rowsCount"
							:hide-default-footer="false"
							:items="displayedItems"
						/>
					</v-col>
				</v-row>
			</v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import SimpleTable from "@/components/story/SimpleTable";
import { mapActions, mapState } from "vuex";
import paymentStateTypes from "@/helpers/paymentStateTypes";

export default {
  components: {
    SimpleTable,
  },
  data: () => ({
    loading: false,
    page: 1,
  }),
  computed: {
    ...mapState("client", ["invoices"]),
    rowsCount() {
      return Math.floor((window.innerHeight - 300) / 55);
    },
    displayedItems() {
      return this.paginate(this.invoices);
    },
    paymentStateTypes() {
      return paymentStateTypes;
    },
    headers(){
      return [
        { text: "Дата рахунку", value: "date", type: "date", width: "12%" },
        { text: "Номер", value: "number", type: "text" },
        { text: "Сума", type: "text", value: "amount" },
        { text: "Оплата", type: "text", value: "payedAmount" },
        { text: "Дата оплати", value: "lastPaymentDate", type: "date" },
        { text: "Статус", component: "Label", value: "paymentStatus", dict: this.paymentStateTypes },
      ];
    },
  },
  watch: {
    invoices() {
      this.setPages();
    },
  },
  async created() {
    await this.getInvoices();
    this.loading = false;
  },
  methods: {
    ...mapActions("client", ["getInvoices"]),
    paginate(items) {
      const page = this.page;
      const perPage = this.rowsCount;
      const from = page * perPage - perPage;
      const to = page * perPage;
      return items.slice(from, to);
    },
    setPages() {
      if (this.rowsCount === null || this.invoices === null) {
        return 0;
      }

      return Math.ceil(this.invoices.length / this.rowsCount);
    },
  },
};
</script>
<style>
.v-application .v-expansion-panel-header.expansion-panel-border {
	background-color: transparent !important;
	border-top: solid 4px transparent;
	border-radius: 0 0 4px 4px;
}
</style>